import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const AUTH_SESSION: InjectionToken<Session> = new InjectionToken('AUTH_SESSION');

export interface Session {
  destroy(): Observable<boolean>;
}
